module.exports = __webpack_public_path__ + "img/compliance.67bcdb5c.svg";